import { AuthServices } from '@/features/auth/services';

/** Deletes a player owned by the signed-in guardian via DELETE /guardians/me/players/{id}. */
export async function deleteGuardianPlayer(playerId: string): Promise<void> {
  await AuthServices.deleteGuardianPlayer(playerId);
}
